module.exports = __webpack_public_path__ + "static/media/drop-slide-6.7d921d28.png";